// UserCreateForm.tsx
import React, { useEffect, useRef } from "react";
import { Form, Input, Typography } from "antd";
import { useTranslation } from "react-i18next";
import AlternativePhoneInput from "../../../../Common/AlternativePhoneInput";
import { useVaadTableGet } from "../../../../../hooks/api/vaads";
import { LazySelect } from "../../../../Common/SelectLazyLoader";

interface UserCreateFormProps {
  hideVaad?: boolean;
  vaadId?: string;
}

export default function UserCreateForm({
  hideVaad,
  vaadId,
}: UserCreateFormProps): React.ReactElement {
  const form = Form.useFormInstance();
  const { t } = useTranslation();

  useEffect(() => {
    if (vaadId) {
      form.setFieldsValue({ vaadId });
    }
  }, [vaadId, form]);

  const vaadsTableGet = useVaadTableGet();
  const vaadMapRef = useRef<Map<string, { name: string; vaadId: any }>>(
    new Map(),
  );

  return (
    <>
      <Form.Item
        label="Full Name"
        name="fullName"
        rules={[
          { required: true },
          { min: 3, max: 150 },
          {
            pattern: /^[A-Za-zÀ-ž\s'-]+$/,
          },
        ]}
      >
        <Input placeholder="Type here" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true },
          { type: "email", message: "Please enter a valid email" },
          { min: 3, max: 150 },
        ]}
      >
        <Input placeholder="Type here" />
      </Form.Item>

      <Form.Item
        label="Phone"
        name="phone"
        rules={[{ required: true }, { min: 3, max: 150 }]}
      >
        <AlternativePhoneInput />
      </Form.Item>

      <Form.Item
        label="Address"
        name="address"
        rules={[{ required: true }, { min: 3, max: 150 }]}
      >
        <Input placeholder="e.g., 2118 Thornridge Cir. Syracuse, Connecticut 35624" />
      </Form.Item>

      {/* Vaad select — простое поле vaadId */}
      {!hideVaad && (
        <Form.Item
          label="Vaad"
          name="vaadId"
          rules={[
            { required: true, message: "Please select at least one vaad" },
          ]}
        >
          <LazySelect
            fetchOptions={async ({ search, page, pageSize }) => {
              const res = await vaadsTableGet.fetch({
                page,
                pageSize,
                search,
              });

              const data = res?.data || [];

              data.forEach((item: any) => {
                vaadMapRef.current.set(item.id, {
                  name: item.name,
                  vaadId: item.id,
                });
              });

              return data;
            }}
            mapOption={(item) => ({
              label: item.name,
              value: item.id,
            })}
            onChange={(value: string) => {
              form.setFieldsValue({ vaadId: value });
              const selected = vaadMapRef.current.get(value);
              console.log("Selected vaad:", selected);
            }}
            pageSize={20}
          />
          <Typography.Paragraph
            type="secondary"
            style={{ marginTop: 8, fontSize: 12 }}
          >
            Selecting at least one vaad is required
          </Typography.Paragraph>
        </Form.Item>
      )}
    </>
  );
}
